import * as React from 'react';
import { defaultIconSize } from '../../style/values';

const style: React.CSSProperties = {
  width: `${defaultIconSize}px`,
  height: `${defaultIconSize}px`,
  margin: 0,
  padding: 0,
  border: 0,
};

const ButtonSpacer: React.SFC = () => <div style={{ ...style }}></div>;

export default ButtonSpacer;
